/***** Begin AgentsNearYouNew Scripts *****/

var AgentsNearYouNew = {

  defaultUserLocation: "",
  SCPageName: "",
  emailAgentIconText: "",
  visitAgentIconText: "",
  getDirectionsLinkText: "",
  callAgentLinkText: "",
  anyNumberAgents: "",
  isEspanol: "",

  init: function (carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding)
  {      
    if (!isCustomer)
    {
      AgentsNearYouNew.parseAgentList(bsCommon.retrieveAgents(), carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding);
      AgentsNearYouNew.subscribeToEvents(carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding);
    }
    else
    {
      AgentsNearYouNew.setUpPagination(carouselId, panelsToDisplay, isCustomer);
      setTimeout(function () { AgentsNearYouNew.checkAgentImages(carouselId) }, 1000);
    }
  },

  subscribeToEvents: function (carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding)
  {
    globalEvents.Event('agentListUpdated').subscribe(function (result) { AgentsNearYouNew.parseAgentList(result, carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding); });
    globalEvents.Event('agentListCleared').subscribe(function () { AgentsNearYouNew.clearAgentList(); });
  },

  setUserLocation: function()
  {
    if (AgentsNearYouNew.defaultUserLocation === "")
    {
      AgentsNearYouNew.defaultUserLocation = $(".AgentsNearYou .headerTitle").html();
    }

    if ((bsCommon.userLocationJson() != null) && (bsCommon.userLocationJson() != "") && (bsCommon.userLocationJson().PostalCode != ""))
    {
      $(".AgentsNearYou .headerTitle").html(AgentsNearYouNew.defaultUserLocation + bsCommon.userLocationJson().PostalCode);
    }
  },

  clearAgentList: function()
  {
    $('.AgentsNearYou .ANYListing .carousel-inner').html("<li><div class='agentsFindMessage'>No Agents Found.</div></li>");
  },

  parseAgentList: function (agentList, carouselId, panelsToDisplay, agentsToDisplay, isCustomer, reviewText, reviewEnding)
  {      
    if (agentList !== null)
    {        
      try
      {
         var myAgents = JSON.parse(agentList);         

        if ((myAgents.Agents !== null) && (myAgents.Agents !== "null") && (myAgents.Agents.length > 0))
        {
          if (myAgents.Agents.length < agentsToDisplay)
          {
            agentsToDisplay = myAgents.Agents.length;
          }

          $('#' + carouselId + ' .carousel-inner').html("");

          if (agentsToDisplay === 1)
          {
            $('.slides_prev-AgentsNearYou .slides_next-AgentsNearYou').hide();
          }
          
          for (var i = 0; i < agentsToDisplay; i++)
          {
              var agentLanguages = "";

              if (AgentsNearYouNew.anyNumberAgents == 1) {
                  $('.slides_prev-AgentsNearYou .slides_next-AgentsNearYou').hide();
              }

              for (j = 0; j < myAgents.Agents[i].Languages.length; j++) {
                  if ((myAgents.Agents[i].Languages[j].toUpperCase() != "ENGLISH") && (j < myAgents.Agents[i].Languages.length)) {
                      if (agentLanguages != "") {
                          agentLanguages = agentLanguages + ", " + myAgents.Agents[i].Languages[j];
                      }
                      else {
                          agentLanguages = myAgents.Agents[i].Languages[j];
                      }
                  }
              }

              var myHTML = "";
              var myAgencyName = myAgents.Agents[i].FullName;
              if ((typeof myAgencyName === 'undefined') || (myAgencyName === '') || (myAgencyName === ' ')) {
                  myAgencyName = myAgents.Agents[i].CFAgencyName;
              }
              if (typeof myAgencyName === 'undefined') {
                  myAgencyName = "Not Available";
              }

              myHTML += "<li class='slides-inner-agentsnearyou'>";
              myHTML += "<div class='agentCard'>";
              myHTML += "<div class='agentContactIcons'>";
              myHTML += "<ul>";
              myHTML += "<li class='agentContactEmail'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;AgentsNearYou&#39;]);' href='mailto:" + myAgents.Agents[i].CFEmailAddress + "' ><i class='fa fa-envelope' aria-hidden='true' title='" + AgentsNearYouNew.emailAgentIconText + "'></i></a></li>";
              myHTML += "<li class='agentContactWebsite'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentsNearYou&#39;]);' href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|website'><i class='fa fa-desktop' aria-hidden='true' title='" + AgentsNearYouNew.visitAgentIconText + "'></i></a></li>";
              if (myAgents.Agents[i].AgentFacebookURL) {
                  myHTML += "<li class='agentContactFacebook'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Facebook&#39;]);' href='" + myAgents.Agents[i].AgentFacebookURL + "' ><i class='fa fa-facebook' aria-hidden='true' title='" + AgentsNearYouNew.AgentFaceBookURLText + "'></i></a></li>";
              }
              if (myAgents.Agents[i].AgentTwitterURL) {
                  myHTML += "<li class='agentContactTwitter'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Twitter&#39;]);' href='" + myAgents.Agents[i].AgentTwitterURL + "' ><i class='fa fa-twitter' aria-hidden='true' title='" + AgentsNearYouNew.AgentTwitterURLText + "'></i></a></li>";
              }
              myHTML += "</ul>";
              myHTML += "</div>";
              myHTML += "<div class='agentPhoto'>";
              myHTML += "<a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|website' title='" + AgentsNearYouNew.visitAgentIconText + "' class='agentWeb' name='&lpos=AgentsNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentsNearYou&#39;]);'><img class='agentPhotoImg' src='" + myAgents.Agents[i].AgentPhotoURL + "' alt='" + myAgencyName + " ' /></a>";
              myHTML += "</div>";
              myHTML += "<div class='agentInfo'>";
              myHTML += "<div class='agentNamePhone'>";
              myHTML += "<div class='agentName'><a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|website' title='" + AgentsNearYouNew.visitAgentIconText + "' class='agentWeb' name='&lpos=AgentsNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentsNearYou&#39;]);'>" + myAgencyName + "</a></div>";
              myHTML += "<div class='agentPhone'>";
              myHTML += "<i class='fa fa-phone' aria-hidden='true'></i>";
              myHTML += "<a href='tel:" + myAgents.Agents[i].Telephone + "' title='" + AgentsNearYouNew.callAgentLinkText + "' class='agentPhone' name='&lpos=AgentsNearYou'>" + myAgents.Agents[i].Telephone + "</a>";
              myHTML += "</div>";
              myHTML += "<a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Reviews&#39;, &#39;AgentsNearYou&#39;]);' href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|5starRatings' class='anyAgentStars-" + myAgents.Agents[i].ProducerNumber + " anyAgentStars'/></a>";
                         
              if (agentLanguages != "" && agentLanguages.length > 0) {
                  if (agentLanguages.length > 35) {
                      myHTML += "<div class='agentLanguages'><i class='glyphicon glyphicon-comment' aria-hidden='true'></i><span class='agentLanguagesSpan'>" + agentLanguages.substring(0, 34) + "</span>";
                      myHTML += " <a name='&lpos=AgentNearYou' class='agentMultipleLangColor' title='" + AgentsNearYouNew.visitAgentIconText + "' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentsNearYou&#39;]);' href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|website'>" + "(+)" + "</a>";
                  } else {
                      myHTML += "<div class='agentLanguages'><i class='glyphicon glyphicon-comment' aria-hidden='true'></i><span class='agentLanguagesSpan'>" + agentLanguages + "</span>";
                  }
                  myHTML += "</div>";
              }

              myHTML += "</div>";
              myHTML += "</div>";
              myHTML += "<div class='agentAddressDiv'>";
              myHTML += "<div class='agentAddressIcon'><i class='fa fa-map-marker' aria-hidden='true'></i></div>";
              myHTML += "<div class='agentAddressLink'>";
              myHTML += "<a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Directions&#39;, &#39;AgentsNearYou&#39;]);' class='agentAddress' title='" + AgentsNearYouNew.getDirectionsLinkText + "' target='_blank' href='https://www.bing.com/mapspreview?rtp=~adr.address." + myAgents.Agents[i].Address.Line1.replace(" ", "%20") + "," + myAgents.Agents[i].Address.City.replace(" ", "%20") + "," + myAgents.Agents[i].Address.AddressState + "," + myAgents.Agents[i].Address.ZipCode + "&intcid=" + AgentsNearYouNew.SCPageName + "|AgentsNearYou|directions'>";
              myHTML += "<p>" + myAgents.Agents[i].Address.Line1 + "</p>";
              myHTML += "<p>" + myAgents.Agents[i].Address.City + ", " + myAgents.Agents[i].Address.AddressState + " " + myAgents.Agents[i].Address.ZipCode + "</p>";
              myHTML += "</a>";
              myHTML += "</div>";
              myHTML += "</div>";
              myHTML += "<div class='agentContactIconsBottom'>";
              myHTML += "<ul>";
              myHTML += "<li class='agentContactPhone'><a href='tel:" + myAgents.Agents[i].Telephone + "'><i class='fa fa-phone' aria-hidden='true' title='" + AgentsNearYouNew.callAgentLinkText + "'></i></a></li>";
              myHTML += "<li class='agentContactEmail'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;AgentsNearYou&#39;])'; href='mailto:" + myAgents.Agents[i].CFEmailAddress + "'><i class='fa fa-envelope' aria-hidden='true' title='" + AgentsNearYouNew.emailAgentIconText + "'></i></a></li>";
              myHTML += "<li class='agentContactWebsite'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentsNearYou&#39;])'; href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentsNearYouNew.SCPageName + "|AgentNearYou|website'><i class='fa fa-desktop' aria-hidden='true' title='" + AgentsNearYouNew.visitAgentIconText + "'></i></a></li>";
              if (myAgents.Agents[i].AgentFacebookURL) {
                  myHTML += "<li class='agentContactFacebook'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Facebook&#39;])'; href='" +myAgents.Agents[i].AgentFacebookURL + "'><i class='fa fa-facebook' aria-hidden='true' title='" +AgentsNearYouNew.AgentFaceBookURLText + "'></i></a></li>";
              }
              if (myAgents.Agents[i].AgentTwitterURL) {
                  myHTML += "<li class='agentContactTwitter'><a name='&lpos=AgentNearYou' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Twitter&#39;, &#39;AgentsNearYou&#39;])'; href='" + myAgents.Agents[i].AgentTwitterURL + "'><i class='fa fa-twitter' aria-hidden='true' title='" + AgentsNearYouNew.AgentTwitterURLText + "'></i></a></li>";
              }
              myHTML += "</ul>";
              myHTML += "</div>";
              myHTML += "</div>";
              myHTML += "</li>";

              $('#' + carouselId + ' .anyAgentListing').append(myHTML);

              if ($('.reviews-' + myAgents.Agents[i].ProducerNumber).length === 0)
              {
                  globalEvents.Event('agentReviewRetrieved').subscribe(function (agentNumber) { AgentsNearYouNew.getReviewDiv(agentNumber, reviewText, reviewEnding); });
                  bsCommon.retrieveAgentReview(myAgents.Agents[i].ProducerNumber);
              }
              else
              {
                  AgentsNearYouNew.getReviewDiv(myAgents.Agents[i].ProducerNumber, reviewText, reviewEnding);
              }
          }

          $('#' + carouselId + ' .anyAgentListing').find('li:first').remove();

          if ($('#' + carouselId + ' .anyAgentListing').children().length == 0) {
              var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
              $('#' + carouselId + ' .anyAgentListing').append(myHTML);
          }

          AgentsNearYouNew.setUpPagination(carouselId, panelsToDisplay, isCustomer);
          setTimeout(function () { AgentsNearYouNew.checkAgentImages(carouselId) }, 1000);
      }
        else
        {
          AgentsNearYouNew.clearAgentList();
      }
  }
      catch (e)
      {
        bsCommon.clearAgents();
      }
    }
    else
    {
      AgentsNearYouNew.clearAgentList();
    }
  },

  checkAgentImages: function (carouselId)
  {
    try
    {
      for (var i = 0; i < $('#' + carouselId).find('img.agentPhotoImg').length; i++)
      {
        if (!bsCommon.isImageOk($('#' + carouselId).find('img.agentPhotoImg')[i]))
        {
          $($('#' + carouselId).find('img.agentPhotoImg')[i]).attr('src', '/resources/images/agent-mia.jpg');

        }
      }
    }
    catch (err)
    {
    }
  },

  //mobileAgentSwipeSlides: function (dir)
  //{
  //    switch (dir)
  //    {
  //        case 'left': $(".slides-outer-navfooter").cycle("next");
  //            break;
  //        case 'right': $(".slides-outer-navfooter").cycle("prev");
  //            break;
  //    }
  //},

  initiateAgentSwipe: function (numItems)
  {      
     if ($(".AgentsNearYou .anyAgentListing").children().length > 0)
     {         
            var myLeftNavHTML = "<a class='slides_prev-agentsnearyou'>Previous</a>";
            var myRightNavHTML = "<a class='slides_next-agentsnearyou'>Next</a>";
            $(".AgentsNearYou .anyAgentsLeft").html(myLeftNavHTML);
            $(".AgentsNearYou .anyAgentsRight").html(myRightNavHTML);
            var owl = $(".AgentsNearYou .anyAgentListing");

            owl.owlCarousel({
                items: numItems,
                itemsCustom: [
                  [0, 1],
                  [768, 2]
                ],
                navigation: true
            });
            
            $(".AgentsNearYou .slides_next-agentsnearyou").unbind("click");
            $(".AgentsNearYou .slides_next-agentsnearyou").click(function ()
            {
                owl.trigger('owl.next');
            })
            $(".AgentsNearYou .slides_prev-agentsnearyou").unbind("click");
            $(".AgentsNearYou .slides_prev-agentsnearyou").click(function ()
            {
                owl.trigger('owl.prev');
            })
            $('.AgentsNearYou .owl-page, .AgentsNearYou .slides_next-agentsnearyou, .AgentsNearYou .slides_prev-agentsnearyou').click(function () { owl.trigger('owl.stop'); });

            //$('.slides-outer-agentsnearyou').swipe(AgentsNearYouNew.mobileAgentSwipeSlides);
      }
  },

  agentCarousel: function (drwNm, drwStep)
  {
      /* single width customer version */
      $('.any-agent-nav').html('');
      $('.AgentsNearYou .slides-inner-agentsnearyou').attr('style', '');
      $('.AgentsNearYou .anyAgentListing').attr('style', '');
      $('#' + drwNm + ' .anyAgentListing').easyPaginate({
          step: drwStep,
          container: 'any-agent-nav',
          controls: 'pagination-nav-any'
      });
  },

  setNavigationText: function ()
  {
      if (typeof myAgentPrevious != "undefined")
      {
          $('.pagination-nav-any .pgPrev').children('a').html(myAgentPrevious);
      }
      if (typeof myAgentNext != "undefined")
      {
          $('.pagination-nav-any .pgNext').children('a').html(myAgentNext);
      }
  },

  agentInitiateNavigation: function (drwNm, drwStep)
  {
      var resizeTimer;

      if ((window.innerWidth < 992) && ($(".AgentsNearYou .anyAgentListing").children().length > 1)) {
          AgentsNearYouNew.initiateAgentSwipe();
          if ((window.innerWidth < 992) && (window.innerWidth > 767) && $(".AgentsNearYou .slides-inner-agentsnearyou").length < 3) {
              $('.AgentsNearYou .anyAgentsRight').css('visibility', 'hidden');
              $('.AgentsNearYou .anyAgentsLeft').css('visibility', 'hidden');
          } else {
              $('.AgentsNearYou .anyAgentsRight').css('visibility', 'visible');
              $('.AgentsNearYou .anyAgentsLeft').css('visibility', 'visible');
          }
      } else {
          AgentsNearYouNew.agentCarousel('AgentsNearYouContainer', drwStep);
          AgentsNearYouNew.setNavigationText();
      }
      //if ((typeof Global !== 'undefined') && (typeof Global.AddResizeEvent === "function")) {
      $(window).resize(function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
              //$('.AgentsNearYou .slides-inner-agentsnearyou').attr('style', '');
              $('.AgentsNearYou .anyAgentListing').attr('style', '');
              if ((window.innerWidth < 992) && ($(".AgentsNearYou .anyAgentListing").children().length > 1)) {
                  $('.AgentsNearYou .slides-inner-agentsnearyou').attr('style', '');
                  AgentsNearYouNew.initiateAgentSwipe();
                  if ((window.innerWidth < 992) && (window.innerWidth > 767) && $(".AgentsNearYou .slides-inner-agentsnearyou").length < 3) {
                      $('.AgentsNearYou .anyAgentsRight').css('visibility', 'hidden');
                      $('.AgentsNearYou .anyAgentsLeft').css('visibility', 'hidden');
                  } else {
                      $('.AgentsNearYou .anyAgentsRight').css('visibility', 'visible');
                      $('.AgentsNearYou .anyAgentsLeft').css('visibility', 'visible');
                  }
              }
              else {
                  //if ($(window).width() == 992) {
                  try {
                      $(".AgentsNearYou .anyAgentListing").data('owlCarousel').destroy();
                  }
                  catch (ex) {
                  }
                  AgentsNearYouNew.agentCarousel('AgentsNearYouContainer', drwStep);
              }
              AgentsNearYouNew.setNavigationText();

          }, 250);          
        });
      //}
  },

  setUpPagination: function (carouselId, panelsToDisplay, isCustomer)
  {
      AgentsNearYouNew.agentInitiateNavigation(carouselId, panelsToDisplay);
      AgentsNearYouNew.setNavigationText();

    if ((navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1))
    {
        $('.AgentsNearYou carousel-control').css('display', '-webkit-inline-box');
    }
  },

  getReviewDiv: function (agentNumber, reviewText, reviewEnding)
  {
    if ($('.reviews-' + agentNumber).length !== 0)
    {
      $('.anyAgentStars-' + agentNumber).empty();
      $('.anyAgentStars-' + agentNumber).append($('.reviews-' + agentNumber).clone().wrap('<div>').parent().html());

      if ($('.anyAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .count')[0].innerHTML !== "1")
      {
        reviewText += reviewEnding;
      }

      $('.anyAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .reviewText').html(reviewText);
    }
  }
};

/***** End AgentsNearYouNew Scripts *****/